import ErrorDispatcher from './ErrorDispatcher';

export class HtmlPreviewErrorDispatcher implements ErrorDispatcher {
  constructor(private error: Error) {}

  getError(): Error {
    return new Error(`An error on html preview: ${this.error.message}`);
  }
}
